// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2trTc","name":"Header_name__2qYGP","birthday":"Header_birthday__3uj7W","skeleton":"Header_skeleton__3JgZQ"};